import { EDebtRecoveryOption, EPaymentReminderStatus, EPreLodEmailType, EReminderStage, EWriteOffReason, ReminderSkipTime } from '../enums/payment-reminder.enum';
import { StageRecord } from '../types';

type PaymentReminderDateField =
  | 'firstReminderIssueDate'
  | 'finalReminderIssueDate'
  | 'lodIssueDate'
  | 'effectiveDate'
  | 'mediationIssueDate'
  | 'arbitrationIssueDate'
  | 'writeOffDate';

export type PaymentReminderStatusItem = {
  id: EPaymentReminderStatus;
  value: EPaymentReminderStatus;
  viewValue: string;
  dateField?: PaymentReminderDateField;
  class: string;
  filterName: string;
};

export const PAYMENT_REMINDER_STATUS: Record<string, PaymentReminderStatusItem> = {
  [EPaymentReminderStatus.draft]: {
    id: EPaymentReminderStatus.draft,
    value: EPaymentReminderStatus.draft,
    viewValue: '',
    class: 'status-box-light-gray',
    filterName: 'No Reminder Status',
  },
  [EPaymentReminderStatus.firstReminder]: {
    id: EPaymentReminderStatus.firstReminder,
    value: EPaymentReminderStatus.firstReminder,
    viewValue: 'First Reminder',
    dateField: 'firstReminderIssueDate',
    class: 'status-box-turquoise-surf',
    filterName: 'First Reminder',
  },
  [EPaymentReminderStatus.finalReminder]: {
    id: EPaymentReminderStatus.finalReminder,
    value: EPaymentReminderStatus.finalReminder,
    viewValue: 'Final Reminder',
    dateField: 'finalReminderIssueDate',
    class: 'status-box-bright-yellow',
    filterName: 'Final Reminder',
  },
  [EPaymentReminderStatus.lod]: {
    id: EPaymentReminderStatus.lod,
    value: EPaymentReminderStatus.lod,
    viewValue: 'LOD',
    dateField: 'lodIssueDate',
    class: 'status-box-vivid-tangelo',
    filterName: 'LOD',
  },
  [EPaymentReminderStatus.debtCollectionAgency]: {
    id: EPaymentReminderStatus.debtCollectionAgency,
    value: EPaymentReminderStatus.debtCollectionAgency,
    viewValue: 'DC',
    dateField: 'effectiveDate',
    class: 'status-box-vivid-crimson',
    filterName: 'DC',
  },
  [EPaymentReminderStatus.mediation]: {
    id: EPaymentReminderStatus.mediation,
    value: EPaymentReminderStatus.mediation,
    viewValue: 'MED',
    dateField: 'mediationIssueDate',
    class: 'status-box-brilliant-azure',
    filterName: 'MED',

  },
  [EPaymentReminderStatus.arbitration]: {
    id: EPaymentReminderStatus.arbitration,
    value: EPaymentReminderStatus.arbitration,
    viewValue: 'ABT',
    dateField: 'arbitrationIssueDate',
    class: 'status-box-purple',
    filterName: 'ABT',
  },
  [EPaymentReminderStatus.smallClaims]: {
    id: EPaymentReminderStatus.smallClaims,
    value: EPaymentReminderStatus.smallClaims,
    viewValue: 'SCT',
    dateField: 'effectiveDate',
    class: 'status-box-grape',
    filterName: 'SCT',
  },
  [EPaymentReminderStatus.civilClaim]: {
    id: EPaymentReminderStatus.civilClaim,
    value: EPaymentReminderStatus.civilClaim,
    viewValue: 'Civil Claim',
    dateField: 'effectiveDate',
    class: 'status-box-zaffer',
    filterName: 'Civil Claim',
  },
  [EPaymentReminderStatus.civilSuit]: {
    id: EPaymentReminderStatus.civilSuit,
    value: EPaymentReminderStatus.civilSuit,
    viewValue: 'Civil Suit',
    dateField: 'effectiveDate',
    class: 'status-box-smokey-topaz',
    filterName: 'Civil Suit',
  },
  [EPaymentReminderStatus.enforcementOfJudgment]: {
    id: EPaymentReminderStatus.enforcementOfJudgment,
    value: EPaymentReminderStatus.enforcementOfJudgment,
    viewValue: 'Enforcement',
    dateField: 'effectiveDate',
    class: 'status-box-electric-orange',
    filterName: 'Enforcement',
  },
  [EPaymentReminderStatus.sctOrder]: {
    id: EPaymentReminderStatus.sctOrder,
    value: EPaymentReminderStatus.sctOrder,
    viewValue: 'SCT Order',
    dateField: 'effectiveDate',
    class: 'status-box-danger',
    filterName: 'SCT Order',
  },
  [EPaymentReminderStatus.writeOff]: {
    id: EPaymentReminderStatus.writeOff,
    value: EPaymentReminderStatus.writeOff,
    viewValue: 'WR',
    dateField: 'writeOffDate',
    class: 'status-box-deep-pink',
    filterName: 'WR',
  },
};

export type DebtRecoveryOptionItem = { id: EDebtRecoveryOption; value: EDebtRecoveryOption; viewValue: string };

export const DEBT_RECOVERY_OPTIONS: Record<string, DebtRecoveryOptionItem> = {
  [EDebtRecoveryOption.arbitration]: { id: EDebtRecoveryOption.arbitration, value: EDebtRecoveryOption.arbitration, viewValue: 'Arbitration' },
  [EDebtRecoveryOption.civilClaim]: { id: EDebtRecoveryOption.civilClaim, value: EDebtRecoveryOption.civilClaim, viewValue: 'Civil Claim' },
  [EDebtRecoveryOption.civilSuit]: { id: EDebtRecoveryOption.civilSuit, value: EDebtRecoveryOption.civilSuit, viewValue: 'Civil Suit' },
  [EDebtRecoveryOption.debtCollectionAgency]: {
    id: EDebtRecoveryOption.debtCollectionAgency,
    value: EDebtRecoveryOption.debtCollectionAgency,
    viewValue: 'Debt collection agency',
  },
  [EDebtRecoveryOption.enforcementOfJudgment]: {
    id: EDebtRecoveryOption.enforcementOfJudgment,
    value: EDebtRecoveryOption.enforcementOfJudgment,
    viewValue: 'Enforcement of Judgment',
  },
  [EDebtRecoveryOption.mediation]: { id: EDebtRecoveryOption.mediation, value: EDebtRecoveryOption.mediation, viewValue: 'Mediation' },
  [EDebtRecoveryOption.sctOrder]: { id: EDebtRecoveryOption.sctOrder, value: EDebtRecoveryOption.sctOrder, viewValue: 'SCT Order' },
  [EDebtRecoveryOption.smallClaims]: { id: EDebtRecoveryOption.smallClaims, value: EDebtRecoveryOption.smallClaims, viewValue: 'Small Claims' },
};

export const MEDIATION_ARBITRATION_OPTIONS = [EDebtRecoveryOption.arbitration, EDebtRecoveryOption.mediation];
export const EFFECTIVE_DATE_OPTIONS = [
  EDebtRecoveryOption.civilClaim,
  EDebtRecoveryOption.civilSuit,
  EDebtRecoveryOption.enforcementOfJudgment,
  EDebtRecoveryOption.sctOrder,
  EDebtRecoveryOption.smallClaims,
];

export const REMINDER_SKIP_TIME_MAP: ReminderSkipTime[] = [ReminderSkipTime.first, ReminderSkipTime.second, ReminderSkipTime.final];

export type WriteOffReasonItem = { id: EWriteOffReason; value: EWriteOffReason; viewValue: string };

export const WRITE_OFF_REASON_OPTIONS: Record<string, WriteOffReasonItem> = {
  [EWriteOffReason.statutoryExpiry]: { id: EWriteOffReason.statutoryExpiry, value: EWriteOffReason.statutoryExpiry, viewValue: 'Expire of the statutory' },
  [EWriteOffReason.unableToContact]: { id: EWriteOffReason.unableToContact, value: EWriteOffReason.unableToContact, viewValue: 'Unable to contact the clients' },
  [EWriteOffReason.others]: { id: EWriteOffReason.others, value: EWriteOffReason.others, viewValue: 'Others' },
}

export const STAGE_OPTIONS: StageRecord = {
  [EReminderStage.firstReminder]: {
    id: EReminderStage.firstReminder,
    value: EReminderStage.firstReminder,
    viewValue: '1st Reminder',
    fileName: 'First Reminder',
  },
  [EReminderStage.finalReminder]: {
    id: EReminderStage.finalReminder,
    value: EReminderStage.finalReminder,
    viewValue: 'Final Reminder',
    fileName: 'Final Reminder',
  },
  [EReminderStage.lod]: {
    id: EReminderStage.lod,
    value: EReminderStage.lod,
    viewValue: 'LOD',
    fileName: 'Letter of Demand',
  },
};

export type PreLodEmailTypeOption = { id: EPreLodEmailType; value: EPreLodEmailType; viewValue: string; sentAt: string | null };

export const PRE_LOD_EMAIL_TYPE_OPTIONS: Record<EPreLodEmailType, PreLodEmailTypeOption> = {
  [EPreLodEmailType.firstPreLod]: {
    id: EPreLodEmailType.firstPreLod,
    value: EPreLodEmailType.firstPreLod,
    viewValue: '1st Pre-LOD',
    sentAt: null
  },
  [EPreLodEmailType.secondPreLod]: {
    id: EPreLodEmailType.secondPreLod,
    value: EPreLodEmailType.secondPreLod,
    viewValue: '2nd Pre-LOD',
    sentAt: null
  },
  [EPreLodEmailType.thirdPreLod]: {
    id: EPreLodEmailType.thirdPreLod,
    value: EPreLodEmailType.thirdPreLod,
    viewValue: '3rd Pre-LOD',
    sentAt: null
  },
};

export type EmailTypeOption = { id: EPreLodEmailType | EReminderStage; value: EPreLodEmailType | EReminderStage; viewValue: string; sentAt: string | null };

export const EMAIL_TYPE_OPTIONS: Record<EPreLodEmailType | EReminderStage, EmailTypeOption> = {
  [EReminderStage.firstReminder]: {
    id: EReminderStage.firstReminder,
    value: EReminderStage.firstReminder,
    viewValue: '1st Reminder',
    sentAt: null
  },
  [EReminderStage.finalReminder]: {
    id: EReminderStage.finalReminder,
    value: EReminderStage.finalReminder,
    viewValue: 'Final Reminder',
    sentAt: null
  },
  [EPreLodEmailType.firstPreLod]: {
    id: EPreLodEmailType.firstPreLod,
    value: EPreLodEmailType.firstPreLod,
    viewValue: '1st Pre-LOD',
    sentAt: null
  },
  [EPreLodEmailType.secondPreLod]: {
    id: EPreLodEmailType.secondPreLod,
    value: EPreLodEmailType.secondPreLod,
    viewValue: '2nd Pre-LOD',
    sentAt: null
  },
  [EPreLodEmailType.thirdPreLod]: {
    id: EPreLodEmailType.thirdPreLod,
    value: EPreLodEmailType.thirdPreLod,
    viewValue: '3rd Pre-LOD',
    sentAt: null
  },
  [EReminderStage.lod]: {
    id: EReminderStage.lod,
    value: EReminderStage.lod,
    viewValue: 'LOD',
    sentAt: null
  },
};